import React, { useCallback, useEffect } from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { number, object } from "yup"
import { autoEuropePricingIdDrawerData, autoEuropePricingIdDrawerErrors } from "Pages/AutoEuropeTool/PricingId/@signals"

export default function AutoEuropePricingIdRecordIdField() {
	const value = autoEuropePricingIdDrawerData.value.pricingRecordId ?? null
	const isEditing = !!autoEuropePricingIdDrawerData.value._isEditing

	const { errors, isValid } = useValidatorSeeker({ pricingRecordId: value }, object({
		pricingRecordId: number()
			.typeError("Pricing Record ID must be a number")
			.required("Pricing Record ID is required")
			.integer("Pricing Record ID must be an integer")
			.positive("Pricing Record ID must be a positive number"),
	}))

	useEffect(() => {
		autoEuropePricingIdDrawerErrors.value = { ...autoEuropePricingIdDrawerErrors.value, pricingRecordId: isValid }
	}, [JSON.stringify(errors)])

	const onChange = useCallback((e) => {
		autoEuropePricingIdDrawerData.value = {
			...autoEuropePricingIdDrawerData.value,
			pricingRecordId: e.target.value === '' ? null : Number(e.target.value),
		}
	}, [])

	return <TextFieldSeeker
		label="Pricing Record ID"
		type="number"
		value={value ?? ""}
		onChange={onChange}
		error={errors?.pricingRecordId}
		disabled={isEditing}
	/>
}